module.exports = __webpack_public_path__ + "img/ai_icon.0ef36249.png";